/**
 * @flow
 * @relayHash 82a5fdcabfd6dad9bd0971874bc53e1f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractContainer_node$ref = any;
export type ContractContainer_RefetchQueryVariables = {|
  id: string
|};
export type ContractContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: ContractContainer_node$ref
  |}
|};
export type ContractContainer_RefetchQuery = {|
  variables: ContractContainer_RefetchQueryVariables,
  response: ContractContainer_RefetchQueryResponse,
|};
*/


/*
query ContractContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...ContractContainer_node
    id
  }
}

fragment ContractContainer_node on Contract {
  id
  title
  terms
  can_edit
  deletable
  editable
  share_token
  brand_logo_url
  brand_header
  contract_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signature_url
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          user_contacts {
            edges {
              node {
                first_name
                last_name
                user_contact_emails {
                  edges {
                    node {
                      address
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "share_token",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ContractContainer_RefetchQuery",
  "id": null,
  "text": "query ContractContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContractContainer_node\n    id\n  }\n}\n\nfragment ContractContainer_node on Contract {\n  id\n  title\n  terms\n  can_edit\n  deletable\n  editable\n  share_token\n  brand_logo_url\n  brand_header\n  contract_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signature_url\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          user_contacts {\n            edges {\n              node {\n                first_name\n                last_name\n                user_contact_emails {\n                  edges {\n                    node {\n                      address\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ContractContainer_RefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractContainer_node",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ContractContainer_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "Contract",
            "selections": [
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "terms",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "deletable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "editable",
                "args": null,
                "storageKey": null
              },
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_logo_url",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_header",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract_event_segments",
                "storageKey": "contract_event_segments(first:99999)",
                "args": v6,
                "concreteType": "ContractEventSegmentConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractEventSegmentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractEventSegment",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line1",
                            "args": null,
                            "storageKey": null
                          },
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "start_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "end_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "time_zone",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "all_day",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "location",
                            "args": null,
                            "storageKey": null
                          },
                          v5,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line2",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "city",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "province",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postal_code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "room",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "notes",
                            "args": null,
                            "storageKey": null
                          },
                          v2
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "contract_event_segments",
                "args": v6,
                "handle": "connection",
                "key": "ContractContainer_contract_event_segments",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract_line_items",
                "storageKey": "contract_line_items(first:99999)",
                "args": v6,
                "concreteType": "ContractLineItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractLineItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractLineItem",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_cents",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_currency",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantity",
                            "args": null,
                            "storageKey": null
                          },
                          v5,
                          v2
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "contract_line_items",
                "args": v6,
                "handle": "connection",
                "key": "ContractContainer_contract_line_items",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract_signature_blocks",
                "storageKey": "contract_signature_blocks(first:99999)",
                "args": v6,
                "concreteType": "ContractSignatureBlockConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractSignatureBlockEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractSignatureBlock",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phone_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "address_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company_name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company_name_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phone",
                            "args": null,
                            "storageKey": null
                          },
                          v9,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signature_type",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signature_typed_name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signature_url",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signed_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signer_fills_fields",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signing_party",
                            "args": null,
                            "storageKey": null
                          },
                          v4,
                          v5,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          v2
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "contract_signature_blocks",
                "args": v6,
                "handle": "connection",
                "key": "ContractContainer_contract_signature_blocks",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [
                              v3,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user_contacts",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EventUserContactConnectionWithRole",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EventUserContactEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserContact",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "first_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "last_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user_contact_emails",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserContactEmailConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserContactEmailEdge",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "UserContactEmail",
                                                    "plural": false,
                                                    "selections": [
                                                      v9,
                                                      v3
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          v3
                                        ]
                                      },
                                      v3
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '58240dc9170224435da557f025d4ac90';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/ContractContainer_RefetchQuery.graphql.js